import type { Company } from '@/apis/generated/dialpad-contact';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type CompanyStore = StoreEntity<Company, 'id', {}>;

export const useCompanyStore = apiStoreFactory<
  CompanyStore['entity'],
  CompanyStore['id'],
  CompanyStore['filter'],
  CompanyStore['createInput'],
  CompanyStore['updateInput']
>(
  STORE.COMPANY,
  { entityIdKey: 'id' },
  {
    read: async (companyId, { contactApi }) => {
      return contactApi.getCompany({
        companyId,
        projection: 'id,key,settings',
      });
    },
  },
);
